import {
  PlanetApostleManageSignature,
  PlanetApostleManageSignInput
} from '@apeiron/planet'
import { deserializeData, MayNull } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { planetApostleManageSignatureSchema } from '@src/deserialize/yup/planet'
import queryGraphQL from '@src/graphql/mutation/signRelicApostleManagement'

const useSignManagePlanetApostle = () => {
  const [signRelicApostleManagement, { loading }] = useMutation(queryGraphQL)

  const mutate = async (
    input: PlanetApostleManageSignInput[]
  ): Promise<MayNull<PlanetApostleManageSignature>> => {
    const res = await signRelicApostleManagement({
      variables: {
        input
      }
    })

    const result = deserializeData<PlanetApostleManageSignature>(
      res,
      planetApostleManageSignatureSchema
    )

    return result
  }

  return {
    mutate,
    loading
  }
}

export default useSignManagePlanetApostle
